import React from 'react'
import { Switch, Typography, Space } from 'antd'
import { formatCurrency } from '../utils'

const ServiceItem = ({ service, isActive, onToggle, style = {} }) => {
  const { Text } = Typography
  const handleToggle = (checked) => {
    onToggle(service._id, checked)
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#ffffff',
        ...style
      }}
    >
      {/* Service Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Space direction='vertical' size={2}>
          <Text
            strong
            style={{
              fontSize: '14px',
              color: '#1f1f1f',
              display: 'block'
            }}
          >
            {service.name}
          </Text>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <Text
              style={{
                fontSize: '13px',
                color: '#666666'
              }}
            >
              {formatCurrency(service.defaultRate)}
            </Text>
            <Text
              style={{
                fontSize: '13px',
                color: '#666666'
              }}
            >
              {service.defaultDurationMin} mins
            </Text>
            {/* {service.specialty && ( TODO: add specialty back in
              <Text
                style={{
                  fontSize: '12px',
                  color: '#1890ff',
                  backgroundColor: '#f6f8ff',
                  padding: '2px 6px',
                  borderRadius: '4px'
                }}
              >
                {service.specialty}
              </Text>
            )} */}
          </div>
        </Space>
      </div>

      {/* Active/Inactive Toggle */}
      <div style={{ marginLeft: '16px' }}>
        <Switch
          checked={isActive}
          onChange={handleToggle}
          checkedChildren='Active'
          unCheckedChildren='Inactive'
          style={{
            backgroundColor: isActive ? '#52c41a' : '#d9d9d9'
          }}
        />
      </div>
    </div>
  )
}

export default ServiceItem
